import { cx } from '@emotion/css';

import PersonalIdentityDialog from 'components/dialogs/PersonalIdentityDialog';
import PageRow from 'components/PageRow';
import ArrowLeft from '@new-components/shapes/ArrowLeft';

import progressImage1 from 'assets/1of3.png';
import progressImage2 from 'assets/2of3.png';
import progressImage3 from 'assets/3of3.png';

// import services from 'services';
import useGlobalState from 'actions';
import { StepProps } from './types';
import { stepCx } from './styles';

const Step = ({
  step = 0,
  padding = 0,
  size,
  className,
  onGoBack,
}: StepProps) => {
  const [state, actions] = useGlobalState();

  let progressImage: string | null = progressImage1;
  let pageHead = 'Identitas Diri';
  if (step === 1) {
    progressImage = progressImage2;
    pageHead = 'Informasi Keluarga';
  } else if (step === 2) {
    progressImage = progressImage3;
    pageHead = 'Keuangan';
  } else if (step === 3) {
    progressImage = null;
    pageHead = 'Review Informasi';
  }

  const goBack = () => {
    onGoBack(step);

    if (step === 0) {
      actions.openPersonalIdentityDialog('preOpen', true);
    } else if (step === 1) {
      // services.ga.sendEventsToGA('Button', 'Click', 'id_appdemo_back');
    } else if (step === 2) {
      // services.ga.sendEventsToGA('Button', 'Click', 'id_appfin_back');
    }
  };

  return (
    <PageRow
      className={cx(
        stepCx,
        'step',
        { 'with-progress': !!progressImage },
        className,
      )}
      padding={padding}
      size={size}
    >
      <div className='back-btn'>
        <ArrowLeft onClick={goBack} />
      </div>
      {progressImage && (
        <div className='progress'>
          <img src={progressImage} alt='progress' />
        </div>
      )}
      <div className='step-title'>
        <span>{pageHead}</span>
      </div>
      <PersonalIdentityDialog preOpen={state.preOpen} />
    </PageRow>
  );
};

export default Step;
